import { ActiveDashboard } from './constants';

const initialState = {
  data: null
};

export const dashboardsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ActiveDashboard.activeDahsboardSuccess:
      return {
        ...state,
        data: action.data
      };
    case ActiveDashboard.fetchDashboardDataSuccess: 
    case ActiveDashboard.refetchDashboardDataSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          charts: state.data?.charts?.map(chart => {
            if (action.data?.[chart.id]) {
              const newChart = action.data?.[chart.id] || {};
              return {
                ...chart,
                data: newChart.data || [],
              }
            } 
              return chart;
          }) || []
        }
      };
    case ActiveDashboard.updateDashboardSuccess:
      return {
        ...state,
        data: action.data
      }
    case ActiveDashboard.removeChartFromDashboardSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          charts: state.data?.charts?.filter(chart => chart.id !== action.data.id) || []
        }
      };
    default:
      return state;
  }
};
